"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringUtilities = {
    slugify: function (text) { var _a; return (_a = text) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(/ /g, '-').replace('.', '-'); },
    sanitizeVariantName: function (modelName, variantName) {
        var _a, _b;
        var modelWords = (_a = modelName) === null || _a === void 0 ? void 0 : _a.split(/\s+/);
        if (!modelName) {
            return variantName;
        }
        return (_b = variantName) === null || _b === void 0 ? void 0 : _b.split(/\s+/).filter(function (part) { return !modelWords.includes(part); }).join(' ');
    }
};
exports.default = stringUtilities;
